// generatorData.js

let cachedData = null;

export const getGeneratorWorkoutData = async () => {
  if (cachedData) return cachedData;

  const token = localStorage.getItem("authToken");
  if (!token) {
    throw new Error("No auth token found");
  }

  const GeneratorWorkoutData = {
    fitness: [],
    focus: [],
    equipment: [],
    injuries: [],
  };

  const fetchWithAuth = async (url) => {
    const response = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      throw new Error(`Failed to fetch ${url}`);
    }

    return response.json();
  };

  try {
    const [fitness, focus, equipment, injuries] = await Promise.all([
      fetchWithAuth("/api/v1/fitness"),
      fetchWithAuth("/api/v1/focus"),
      fetchWithAuth("/api/v1/equipment"),
      fetchWithAuth("/api/v1/injuries"),
    ]);

    GeneratorWorkoutData.fitness = fitness;
    GeneratorWorkoutData.focus = focus;
    GeneratorWorkoutData.equipment = equipment;
    GeneratorWorkoutData.injuries = injuries;

    cachedData = GeneratorWorkoutData;
    console.log("Workout data loaded:", cachedData);
    return cachedData;
  } catch (error) {
    console.error("Error loading generator workout data:", error);
    throw error;
  }
};


// const token = localStorage.getItem("authToken"); 
// const GeneratorWorkoutData = {
    
//     fitness: [], 
//     focus: [],
//     equipment: [],
//     injuries: [], 
    
// };

// console.log('Generated Dat', GeneratorWorkoutData);
// // Function to fetch fitness data from the backend
// async function fetchFitnessData() {

//     try {
//         const response = await fetch('/api/v1/fitness', {
//             method: 'GET',
//             headers: {
//                 'Content-Type': 'application/json',
//                 Authorization: `Bearer ${token}`,
//             }
//         });


//         if (!response.ok) {
//             throw new Error('Network response was not ok');
//         }

//         const data = await response.json();
//         // console.log('fitness data', data);
//         GeneratorWorkoutData.fitness = data; 
//     } catch (error) {
//         console.error('Error fetching fitness data:', error);
//     }
// }

// async function fetchfocusData() {

//     try {
//         const response = await fetch('/api/v1/focus', {
//             method: 'GET',
//             headers: {
//                 'Content-Type': 'application/json',
//                 Authorization: `Bearer ${token}`,
//             }
//         });


//         if (!response.ok) {
//             throw new Error('Network response was not ok');
//         }

//         const data = await response.json();
//         // console.log('focus data', data);
//         GeneratorWorkoutData.focus = data; 
//     } catch (error) {
//         console.error('Error fetching focus data:', error);
//     }
// }

// async function fetchEquipmentData() {

//     try {
//         const response = await fetch('/api/v1/equipment', {
//             method: 'GET',
//             headers: {
//                 'Content-Type': 'application/json',
//                 Authorization: `Bearer ${token}`,
//             }
//         });


//         if (!response.ok) {
//             throw new Error('Network response was not ok');
//         }

//         const data = await response.json();
//         // console.log('equipment data', data);
//         GeneratorWorkoutData.equipment = data; 
//     } catch (error) {
//         console.error('Error fetching equipment data:', error);
//     }
// }

// // Function to fetch injuries data from the backend
// async function fetchInjuriesData() {
//     try {
//         const response = await fetch('/api/v1/injuries', {
//             method: 'GET',
//             headers: {
//                 'Content-Type': 'application/json',
//                 Authorization: `Bearer ${token}`,
//             }
//         });

//         if (!response.ok) {
//             throw new Error('Network response was not ok');
//         }

//         const data = await response.json();
//         console.log('injuries data', data);
//         GeneratorWorkoutData.injuries = data; // Update the injuries data
//     } catch (error) {
//         console.error('Error fetching injuries data:', error);
//     }
// }

// // Call the functions to fetch data
// async function fetchData() {
//     await Promise.all([fetchFitnessData(), fetchfocusData(), fetchEquipmentData(), fetchInjuriesData()]);
// }

// fetchData();

// export default GeneratorWorkoutData;


// import fitnessData from "../../data/fitness.json";
// import areaData from "../../data/area.json";
// import equipmentData from "../../data/equipment.json";
// import injuriesData from "../../data/injuries.json";

// const GeneratorWorkoutData = {
//     fitness: fitnessData,
//     focus: areaData,
//     equipment: equipmentData,
//     injuries: injuriesData,
// };

// export default GeneratorWorkoutData;